import { useAuthActions } from "@convex-dev/auth/react";

import { Button } from "@/components/ui/button";
import { GitHubLogo } from "@/components/ui/GitHubLogo";
import { GoogleLogo } from "@/components/ui/GoogleLogo";

export const SignIn = () => {
  const { signIn } = useAuthActions();

  return (
    // TODO: test this on mobile - is dvh and dvw correct? or should we use h-screen/w-screen (which use vh/vw)
    <div className="flex flex-col h-dvh w-dvw overflow-hidden bg-muted">
      {/* Top bar */}
      <div className="w-full bg-background shadow-sm px-6 py-4">
        <h2 className="text-xl font-semibold">17reviews</h2>
      </div>

      {/* Main content */}
      <div className="flex flex-col items-center flex-1 overflow-auto pt-14 sm:pt-20 md:pt-28 px-4">
        <div className="relative w-full max-w-[340px] sm:max-w-[440px] md:max-w-[510px] mx-auto">
          {/* Main card with content */}
          <div className="bg-background rounded-lg shadow-lg p-4 sm:p-6 md:p-8 relative z-30 w-full">
            <div className="text-left">
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-4 leading-tight">
                Efficiently memorize the knowledge that matters to you.
              </h1>
              <p className="text-sm sm:text-base mb-4 sm:mb-6">
                17reviews is a flashcard app based on spaced repetition.
              </p>

              <div className="mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-gray-200 flex flex-col gap-2">
                <Button
                  type="button"
                  variant="outline"
                  className="w-full"
                  onClick={() => void signIn("github")}
                >
                  <GitHubLogo />
                  Sign in with GitHub
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  className="w-full"
                  onClick={() => void signIn("google")}
                >
                  <GoogleLogo className="mr-2 h-4 w-4" /> Sign in with Google
                </Button>
              </div>
            </div>
          </div>

          {/* Second card (middle) */}
          <div className="absolute bg-background rounded-lg shadow-md w-[98%] h-[98%] bottom-[-8px] left-[1%] z-20"></div>

          {/* Third card (bottom) */}
          <div className="absolute bg-background rounded-lg shadow-sm w-[96%] h-[96%] bottom-[-16px] left-[2%] z-10"></div>
        </div>
        {/* Add bottom padding to ensure there's space when vertically constrained */}
        <div className="py-6"></div>
      </div>
    </div>
  );
};
